module.exports = __webpack_public_path__ + "img/sec222.64668fa8.jpg";